var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();$event.stopPropagation();return _vm.submit.apply(null, arguments)}}},[_vm._t("default",null,{"handleValidity":_vm.handleValidity})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }